import { forwardRef } from "react";
import * as SelectPrimitive from "@radix-ui/react-select";

import type {
  TSelectViewportElement,
  TSelectViewportProps,
} from "@/ui/components/form/Select/Select.config";
import { cn } from "@/ui/lib/utils";

export const SelectViewport = forwardRef<TSelectViewportElement, TSelectViewportProps>(
  (
    {
      className,
      position,
      ...props
    },
    ref,
  ) => (
    <SelectPrimitive.Viewport
      data-component="SelectViewport"
      ref={ref}
      className={cn(
        "p-1",
        position === "popper" && "w-full",
        className,
      )}
      {...props}
    />
  ),
);

SelectViewport.displayName = SelectPrimitive.Viewport.displayName;
